// src/components/VersionChecker.js
import React, { useEffect, useState } from 'react';
import { APP_VERSION } from '../config';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';

const VersionChecker = () => {
  const [latestVersion, setLatestVersion] = useState(APP_VERSION);
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (response.ok) {
          const data = await response.json();
          if (data.version !== APP_VERSION) {
            setLatestVersion(data.version);
            setUpdateAvailable(true);
          }
        }
      } catch (error) {
        console.error("Errore nel controllo della versione:", error);
      }
    };

    checkVersion();
    const interval = setInterval(checkVersion, 300000);
    return () => clearInterval(interval);
  }, []);

  const handleUpdate = () => {
    window.location.reload(true);
  };

  return (
    <Dialog open={updateAvailable}>
      <DialogTitle>Aggiornamento Disponibile</DialogTitle>
      <DialogContent>
        <Typography>
          Una nuova versione ({latestVersion}) dell'app è disponibile. Clicca sul pulsante per aggiornare.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleUpdate} color="primary" variant="contained">
          Aggiorna Ora
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default VersionChecker;
